/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck

import { mapValidUntil } from '../utils/date-utils';
import { t } from '../locales/i18n';
export const GET_COMMENTS_SAGA = 'comments/GET_COMMENTS_SAGA';
export const COMMENT_INSERT_SAGA = 'comments/COMMENT_INSERT_SAGA';
export const COMMENT_DELETE_SAGA = 'comments/COMMENT_DELETE_SAGA';
export const COMMENT_UPDATE_SAGA = 'comments/COMMENT_UPDATE_SAGA';
export const COMMENT_ADD_CHANGED = 'comments/COMMENT_ADD_CHANGED';
export const GET_COMMENTS_RESPONSE = 'web-socket/get-comments/cbx';

export const COMMENT_INSERTED = 'web-socket/add-comment/cbx';

export function getCommentsSaga() {
  return { type: GET_COMMENTS_SAGA };
}

const initialState = {
  items: [],
  commentToAdd: null
};

export function commentAddChanged(comment) {
  return { type: COMMENT_ADD_CHANGED, commentToAdd: comment };
}

export function commentInsertSaga(comment) {
  return { type: COMMENT_INSERT_SAGA, comment };
}

export function commentDeleteSaga(commentId) {
  return { type: COMMENT_DELETE_SAGA, commentId };
}

export function commentUpdateSaga(comment) {
  return { type: COMMENT_UPDATE_SAGA, comment };
}

function mapVisibility(c) {
  const key = c.visibility;
  switch (key) {
    case 'queue': {
      return {
        key,
        title: t('commentVisibility.queue', { queue: c.queueSequenceId })
      };
    }
    case 'ticket': {
      return {
        key,
        title: t('commentVisibility.ticket', { ticket: c.ticketDisplayName })
      };
    }
    default: {
      return { key, title: t('commentVisibility.all') };
    }
  }
}

function mapCommentItem(c) {
  const validUntilData = mapValidUntil(c.validUntil);
  const visibilityData = mapVisibility(c);
  return {
    validUntilData,
    visibilityData,
    ...c
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COMMENTS_RESPONSE: {
      const items = action.comments.map(mapCommentItem);
      return { ...state, items };
    }
    case COMMENT_ADD_CHANGED: {
      const commentToAdd = action.commentToAdd;
      return { ...state, commentToAdd };
    }
    case COMMENT_INSERTED: {
      return { ...state, commentToAdd: null };
    }
    default: {
      return state;
    }
  }
}
